import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'
import { VendorResponse } from './model'

export interface State extends EntityState<VendorResponse> {
  isLoaded: boolean
}

export const adapter: EntityAdapter<VendorResponse> = createEntityAdapter<VendorResponse>({
  selectId: (item) => item.pkey,
  sortComparer: false,
})

export const initialState: State = adapter.getInitialState({
  isLoaded: false,
})
